var _defs, _path, _polygon, _polygon2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv5MondePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1552.88 1552.88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #0a0f0f;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        fill: #ebafcd;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 556.14,
    y: 1001.02,
    width: 445.51,
    height: 115.39,
    id: "rect1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2550.49,
    y1: 1121.24,
    x2: 2565.76,
    y2: 1121.24,
    gradientTransform: "translate(-73847.71 33767.93) scale(29.17 -29.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05a30",
    id: "stop1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfd02d",
    id: "stop2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 711.77,
    y: 844.46,
    width: 134.25,
    height: 432.77,
    id: "rect2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2635.29,
    y1: 1029.37,
    x2: 2650.56,
    y2: 1029.37,
    gradientTransform: "translate(-21463.45 -56072.48) rotate(90) scale(21.61 -21.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e79fc5",
    id: "stop3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e79fc5",
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfd02d",
    id: "stop5"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1552.88,
    height: 1552.88,
    rx: 326.56,
    ry: 326.56,
    id: "rect5",
    style: {
      fill: "#000000"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1118.07,398.6c0-70.88-105.48-47.59-105.49-47.59l4.24-18.85,89.24-.11v-49.26l-133.46.09-19.57,109.87c4.21-.84,108.37-22.74,108.37,5.81,0,45.85-111.59,12.29-111.59,12.29l-7.86,44.12s30.38,14.9,70.86,14.9c64.78,0,105.27-27.11,105.27-71.25",
    id: "path5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "604.87 331.73 551.78 331.73 551.78 469.85 487.9 469.85 487.99 331.73 434.81 331.73 434.81 282.79 604.87 282.79 604.87 331.73",
    id: "polygon5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "810.9 469.85 864.97 282.79 806.67 282.79 774.84 400.58 743.01 282.79 684.7 282.79 738.78 469.85 810.9 469.85",
    id: "polygon6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "297.69 558.94 269.36 612.95 241.02 558.94 184.43 558.94 184.43 745.76 232.94 745.77 232.94 648.19 253.61 683.49 285.1 683.49 305.77 648.19 305.77 745.77 354.28 745.76 354.28 558.94 297.69 558.94",
    id: "polygon7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "815.27 558.93 815.27 661.98 750.55 558.93 693.97 558.93 693.97 745.76 742.46 745.76 742.46 642.49 807.49 745.76 863.82 745.76 863.82 558.93 815.27 558.93",
    id: "polygon8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1347.94 674.59 1259.69 674.59 1259.69 698.63 1368.45 698.63 1368.45 745.76 1207.09 745.76 1207.09 558.94 1368.45 558.94 1368.45 606.02 1259.69 606.02 1259.69 630.11 1347.94 630.11 1347.94 674.59",
    id: "polygon9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M609.89,666.19c0,12.09-1.96,23.22-5.89,33.4-3.93,10.18-9.6,18.94-17.03,26.27-7.43,7.33-16.47,13.05-27.14,17.15-10.66,4.1-21.49,6.15-34.86,6.15s-26.45-2.05-36.84-6.15c-10.41-4.1-19.16-9.84-26.27-17.21-7.11-7.38-12.52-16.14-16.24-26.27-3.72-10.14-5.57-21.25-5.57-33.33v-27.43c0-12.08,1.85-23.21,5.57-33.39,3.72-10.18,9.13-18.97,16.24-26.34,7.11-7.37,15.84-13.14,26.18-17.28,10.35-4.14,23.56-6.21,36.93-6.21s24.2,2.08,34.86,6.21c10.67,4.14,19.71,9.9,27.14,17.28,7.43,7.37,13.1,16.16,17.03,26.34,3.93,10.18,5.89,21.31,5.89,33.39v27.43ZM556.36,651.7c0-7-.61-13.44-1.83-19.34-1.22-5.9-3.14-10.97-5.75-15.22-2.61-4.24-5.96-7.57-10.04-9.96-4.09-2.4-7.96-3.6-13.77-3.6s-11.6,1.2-15.47,3.6c-3.87,2.4-6.99,5.72-9.35,9.96-2.36,4.25-4.04,9.32-5.05,15.22-1.01,5.9-1.52,12.34-1.52,19.34v.88c0,6.92.5,13.32,1.52,19.22,1.01,5.9,2.69,11.01,5.05,15.34,2.36,4.32,5.48,7.7,9.35,10.14,3.87,2.44,9.66,3.66,15.47,3.66s9.69-1.22,13.77-3.66c4.08-2.44,7.41-5.8,9.98-10.08,2.57-4.29,4.49-9.38,5.75-15.28,1.26-5.9,1.89-12.34,1.89-19.34v-.88Z",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M948.69,745.88v-186.83h85.72c24.34-.11,46.74,7.7,63.32,24.06,16.15,16.13,23.91,38.24,23.84,61.79v15.39c.1,23.49-7.75,45.48-23.64,61.66-7.47,7.57-16.44,13.46-26.91,17.65-10.48,4.19-28.27,6.29-40.92,6.29h-81.41ZM1005.56,607.35v90.01c9.97-.29,27.53,1.36,36.36-3.02,16.28-6.82,22.45-24.01,22.31-41.3.53-17.55-5.94-35.52-22.77-42.47-8.78-4.44-25.84-3.01-35.9-3.22",
    id: "path10"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7",
    clipPath: "url(#clippath)",
    id: "g11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 556.14,
    y: 1001.02,
    width: 445.51,
    height: 115.39,
    id: "rect10"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    clipPath: "url(#clippath-1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 711.77,
    y: 844.46,
    width: 134.25,
    height: 432.77,
    id: "rect11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv5MondePlus);
export default __webpack_public_path__ + "static/media/TV5MondePlus.a0b0bdd52d1dbe47e9465e7600049ff7.svg";
export { ForwardRef as ReactComponent };